import React from 'react';

const HorizontalBarChartIcon = ({ size }: { size: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height="62"
      fill="none"
      viewBox="0 0 80 56"
    >
      <path
        fill="#3B82F6"
        d="M48 6H10a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h38a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2"
        opacity="0.85"
      ></path>
      <path
        fill="#818CF8"
        d="M34 17H10a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2"
        opacity="0.85"
      ></path>
      <path
        fill="#3B82F6"
        d="M58 28H10a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h48a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2"
        opacity="0.85"
      ></path>
      <path
        fill="#818CF8"
        d="M40 39H10a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2"
        opacity="0.85"
      ></path>
    </svg>
  );
};

export default HorizontalBarChartIcon;
